import React from 'react';

const STROKE_WIDTH = 2.1;

const SpeakerWaveIcon: React.FC<React.SVGProps<SVGSVGElement> & { muted?: boolean }> = ({ muted = false, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={STROKE_WIDTH} {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 10.5h3.2L12 7.25v9.5l-3.8-3.25H5z" />
    {muted ? (
      <>
        <path strokeLinecap="round" strokeLinejoin="round" d="M16 9l5 6" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 9l-5 6" />
      </>
    ) : (
      <>
        <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 9.5a4.25 4.25 0 0 1 0 5" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 7a7.5 7.5 0 0 1 0 10" />
      </>
    )}
  </svg>
);

export default SpeakerWaveIcon;
